const rawBugWidgetSrc = import.meta.env.VITE_BUG_WIDGET_URL?.trim() || '';

let parsedBugWidgetUrl = null;

if (rawBugWidgetSrc) {
    try {
        parsedBugWidgetUrl = new URL(rawBugWidgetSrc);
    } catch (error) {
        parsedBugWidgetUrl = null;
        console.error('[Bug Widget] Invalid VITE_BUG_WIDGET_URL:', error);
    }
}

export const BUG_WIDGET_SRC = parsedBugWidgetUrl?.toString() || '';
export const BUG_WIDGET_ORIGIN = parsedBugWidgetUrl?.origin || '';
